export default __webpack_public_path__ + "ecbdd5a240a03d64fa3a639ca0fbed79.png";